const isIframe = () => {
  return window.self !== window.top;
};

export default isIframe;
